import State from '../core/State';
import { SummaryData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingUsersSummary = () =>
  produce((draft: Draft<State>) => {
    draft.usersSummary.fetching = draft.usersSummary.fetching + 1;
  });

export const setUsersSummary = (summaries: SummaryData[]) =>
  produce((draft: Draft<State>) => {
    draft.usersSummary.data = summaries;
  });

export const finishFetchingUsersSummary = () =>
  produce((draft: Draft<State>) => {
    draft.usersSummary.fetching = draft.usersSummary.fetching - 1;
  });

export const disposeUsersSummary = () =>
  produce((draft: Draft<State>) => {
    draft.usersSummary.data = initialState.usersSummary.data;
    draft.usersSummary.fetching = initialState.usersSummary.fetching;
  });
